import { useNavigate } from "react-router-dom";
import TopBar from "@/components/TopBar";
import { useOutfitDraft } from "@/context/OutfitDraftContext";

export default function ProfileScreen() {
  const navigate = useNavigate();
  const { draft, update } = useOutfitDraft();

  const setField = (k) => (e) => update({ [k]: e.target.value });

  const next = () => navigate("/results");

  return (
    <div className="screen fade-in" data-testid="profile-screen">
      <TopBar title="STEP 3 OF 3" />
      <div style={{ marginBottom: 22 }}>
        <div className="eyebrow" style={{ marginBottom: 10 }}>YOU</div>
        <h2 className="h1" style={{ fontSize: 34 }}>
          A few <em className="serif" style={{ fontStyle: "italic", fontWeight: 300 }}>details</em>
        </h2>
        <p className="body" style={{ marginTop: 12 }}>
          Everything is optional. The more we know, the better the fit.
        </p>
      </div>

      <div className="stagger" style={{ display: "flex", flexDirection: "column", gap: 14, flex: 1 }}>
        <div className="field">
          <label className="label" htmlFor="height">Height</label>
          <input
            id="height"
            type="text"
            className="input"
            placeholder='e.g. 5&#39;10" or 178 cm'
            value={draft.height}
            onChange={setField("height")}
            data-testid="profile-height-input"
          />
        </div>
        <div className="field">
          <label className="label" htmlFor="weight">Weight</label>
          <input
            id="weight"
            type="text"
            className="input"
            placeholder="e.g. 160 lb or 73 kg"
            value={draft.weight}
            onChange={setField("weight")}
            data-testid="profile-weight-input"
          />
        </div>
      </div>

      <div style={{ marginTop: 18 }}>
        <button className="btn btn-primary" onClick={next} data-testid="profile-generate-btn">
          Generate outfit
        </button>
      </div>
    </div>
  );
}
